import { render, staticRenderFns } from "./FormAssocianteEnderecos.vue?vue&type=template&id=07712900"
import script from "./FormAssocianteEnderecos.vue?vue&type=script&lang=js"
export * from "./FormAssocianteEnderecos.vue?vue&type=script&lang=js"
import style0 from "./FormAssocianteEnderecos.vue?vue&type=style&index=0&id=07712900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports